import { toRef, computed } from 'vue'
import { useVenueEvent } from '../features/venue-booking/useVenueEvent'
import { useArtistEvent } from '../features/artist-booking/useArtistEvent'

export const useEventCards = (props) => {
    const event = toRef(props, 'event')
    const variant = toRef(props, 'variant')
    const {
        venueEventLabel,
        venueLocation,
        venueEventVibes,
        venueEventImage,
        venueEventDate,
        venuePayout,
        venueCta,
        venueEventArtists: eventArtists
    } = useVenueEvent(event)
    const {
        //
        artistEventLabel,
        artistEventVibes,
        artistEventImage,
        artistEventDate,
        artistPayout,
        artistCta
    } = useArtistEvent(event)

    const eventVibes = computed(() => {
        let keywords
        let vibes

        switch (variant.value) {
            case 'artist':
                vibes = artistEventVibes.value
                break
            case 'venue':
                vibes = venueEventVibes.value
                break
            default:
                return []
        }

        if (vibes?.length > 3) {
            keywords = vibes.slice(0, 3).join(', ')
            keywords = `${keywords} and ${vibes.length - 3} more...`
        } else {
            keywords = vibes?.join(', ') ?? ''
        }
        return keywords
    })
    const eventImage = computed(() => {
        switch (variant.value) {
            case 'artist':
                return artistEventImage.value
            case 'venue':
                return venueEventImage.value
            default:
                return ''
        }
    })
    const eventDate = computed(() => {
        switch (variant.value) {
            case 'artist':
                return artistEventDate.value
            case 'venue':
                return venueEventDate.value
            default:
                return ''
        }
    })
    const eventPayout = computed(() => {
        switch (variant.value) {
            case 'artist':
                return artistPayout.value
            case 'venue':
                return venuePayout.value
            default:
                return ''
        }
    })
    const cta = computed(() => {
        switch (variant.value) {
            case 'artist':
                return artistCta.value
            case 'venue':
                return venueCta.value
            default:
                return {}
        }
    })
    const eventLabel = computed(() => {
        switch (variant.value) {
            case 'artist':
                return artistEventLabel.value
            case 'venue':
                return venueEventLabel.value
            default:
                return ''
        }
    })

    return {
        eventVibes,
        eventImage,
        eventDate,
        eventArtists,
        venueLocation,
        eventPayout,
        cta,
        eventLabel
    }
}
